import React from 'react';
import styled from 'styled-components';
import { CollapsibleSuggestionsPanel } from './ItemSuggestions';

const GUIDELINES = {
  designer: {
    title: 'Please Review Our Designer Guidelines first',
    emoji: '🎨',
    definition: 'Artists & Designers who create and sell original products designed by themselves or their brand.',
    mustHaves: [
      'Original designs or artwork.',
      'Excellent Quality',
      'Strong creative identity.',
      'Products reflect the brand\'s own design language.',
      'Consistent quality.',
      'Professional branding and Photography',
      'Well Packaged Products',
    ],
    note:
      'If your shop meets Artist & Designer criteria Flea team accepts your catalogue OR We may contact you to take your approval before we accept your catalogue as a Boutique as per Flea\'s criteria to keep our promise for uniqueness, quality, competence, and values.',
  },
  boutique: {
    title: 'Please Review Our Boutique Guidelines first',
    emoji: '🏪',
    definition: 'Businesses that curate premium fashion, beauty, bridal, accessories or lifestyle collections.',
    mustHaves: [
      'Clear boutique identity.',
      'Carefully curated catalog.',
      'Professional visual branding.',
      'Consistent aesthetic.',
    ],
    note:
      'Your listing type may get accepted or rejected as per Flea\'s criteria to keep our promise for quality, competence, and values.',
  },
  'local-shop': {
    title: 'Please Review Our Local Shop Guidelines first',
    emoji: '🏘️',
    definition: 'Retail businesses selling products within one or more categories.',
    mustHaves: [
      'Professional catalog.',
      'Reliable product quality.',
      'Clear business identity.',
      'Organized listings.',
      'Consistent presentation.',
    ],
    note:
      'Your listing type may get accepted but listed in another category that suits your brand and positioning as per Flea\'s criteria to keep our promise for uniqueness, quality, competence, and values.',
  },
};

const PolicyBody = styled.div`
  color: #1e293b;
  font-size: 0.95rem;
  line-height: 1.55;

  h3 {
    margin: 0.75rem 0 0.4rem;
    color: #0f172a;
    font-size: 0.95rem;
    font-weight: 700;
  }

  h3:first-child {
    margin-top: 0;
  }

  p {
    margin: 0 0 0.75rem;
    color: #334155;
  }

  ul {
    margin: 0 0 0.75rem;
    padding-left: 1.25rem;
  }

  li {
    color: #475569;
    font-size: 0.875rem;
    line-height: 1.6;
    margin-bottom: 0.2rem;
  }

  strong {
    color: #0f172a;
    font-weight: 700;
  }
`;

const NoteBox = styled.div`
  background: #fef9c3;
  border: 1px solid #fde047;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  margin-top: 0.75rem;
  font-size: 0.88rem;
  color: #854d0e;
  line-height: 1.5;
`;

const ListingTypeGuidelines = ({ type = 'designer', defaultExpanded = false }) => {
  const guide = GUIDELINES[type] || GUIDELINES.designer;

  return (
    <CollapsibleSuggestionsPanel title={guide.title} defaultExpanded={defaultExpanded}>
      <PolicyBody>
        <h3>{guide.emoji} Definition</h3>
        <p>{guide.definition}</p>

        <h3>✅ Must Have</h3>
        <ul>
          {guide.mustHaves.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </PolicyBody>

      <NoteBox>
        💡 <strong>Note:</strong> {guide.note}
      </NoteBox>
    </CollapsibleSuggestionsPanel>
  );
};

export default ListingTypeGuidelines;
